export interface IEventEndDates {
  endDate?: string | null;
  optimizedEndDate?: string | null;
}

export const getEventEndDate = (event: IEventEndDates): string | null =>
  event.endDate ?? event.optimizedEndDate ?? null;
